import React, { useEffect } from "react";
import styled from "styled-components";
// import TimeAgo from "javascript-time-ago";
import { useDetectClickOutside } from "react-detect-click-outside";

//icons
import emptydrop from "../img/icons/emptymsg.svg";
// import en from "javascript-time-ago/locale/en";

// TimeAgo.addDefaultLocale(en);

// const timeAgo = new TimeAgo("en-US");

export default function DropdownN(props) {
  useEffect(() => {
    isvisible();
    window.addEventListener("scroll", function () {
      isvisible();
    });
  });

  const refs = useDetectClickOutside({
    onTriggered: handleClickOut,
    triggerKeys: ["Escape"],
  });
  function handleClickOut() {
    props.setShow(false);
  }

  const isvisible = () => {
    const element = document.getElementById("menuN");
    if (element) {
      var position = element.getBoundingClientRect();
      if (position.right > window.innerWidth) {
        element.style.right = window.innerWidth - position.right + "px";
      }
    }
  };
  return (
    <>
      {props.show && (
        <Menu
          id="menuN"
          onClick={(e) => {
            e.stopPropagation();
          }}
          ref={refs}
          style={{ ...{ margin: "10px" }, ...props.style }}
        >
          {props.options.length !== 0 ? (
            <Wrapper>
              <Header>
                <Title>{props.title}</Title>
                <ReadMark
                  type="button"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (typeof props.onMarkAllRead === "function") props.onMarkAllRead();
                  }}
                >
                  Mark all as read
                </ReadMark>
              </Header>
              <Clm>
                {props.options.map(function (ob, i) {
                  return (
                    <Row
                      key={i}
                      className={ob.notRead === true ? "notread" : ""}
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        if (typeof props.onItemClick === "function") props.onItemClick(ob);
                        // Close dropdown after click if parent provided a setter
                        if (typeof props.setShow === "function") props.setShow(false);
                      }}
                    >
                      <Avatar>
                        {ob?.emoji ? (
                          <EmojiIcon aria-hidden="true">{ob.emoji}</EmojiIcon>
                        ) : ob?.profileImg ? (
                          <img src={ob.profileImg} alt={ob.fullName} />
                        ) : (
                          <EmojiIcon aria-hidden="true">🏆</EmojiIcon>
                        )}
                      </Avatar>
                      <Text>
                        <TopRow>
                          <Name>{ob.fullName}</Name>
                          {ob?.badgeText ? (
                            <Badge className={ob?.badgeVariant || "neutral"}>{ob.badgeText}</Badge>
                          ) : null}
                        </TopRow>
                        <Massege>{ob.data}</Massege>
                      </Text>
                      {/* <Time>{timeAgo.format(Date.now() - 60 * 1000)}</Time> */}
                    </Row>
                  );
                })}
              </Clm>
            </Wrapper>
          ) : (
            <Empty>
              <div>
                <img src={emptydrop} alt="Empty notifications" />
                <div>No Notifications</div>
              </div>
            </Empty>
          )}
        </Menu>
      )}
    </>
  );
}
const Menu = styled.div`
  cursor: initial;
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 360px;
  height: 420px;
  z-index: 300;
  background-color: ${({ theme }) => theme.color.background};
  /* shadow-sm */
  box-shadow: 0px 2px 7px rgba(0, 0, 0, 0.07);
  border-radius: 8px;
  overflow: hidden;
  @media only screen and (max-width: 576px) {
    border-radius: 13px 13px 0px 0px;
    position: fixed;
    top: unset !important;
    bottom: 0 !important;
    left: 0 !important;
    margin: 0 !important;
    transform: translate(0, 0) !important;
    min-width: 100%;
    width: 100%;
    padding: 6px 14px;
    font-size: 10px;
    line-height: 10px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 320px;
  height: 48px;
  background: ${({ theme }) => theme.color.bg};
  border-bottom: 1px solid #f0f4f8;
  margin-bottom: 10px;
  @media only screen and (max-width: 576px) {
    width: 100%;
  }
  /* shadow-sm */
`;
const Clm = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 360px;
  gap: 2px;
  background: ${({ theme }) => theme.color.bg};
  overflow: auto;
  @media only screen and (max-width: 576px) {
    width: 100%;
  }
`;
const Title = styled.div`
  color: ${({ theme }) => theme.color.darkerText};
  font-family: "Poppins Bold";
  font-size: 16px;
  line-height: 120%;
`;
const ReadMark = styled.button`
  color: ${({ theme }) => theme.color.primaryText};
  font-family: "Poppins Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 10px;
  line-height: 120%;
  background: transparent;
  outline: "none";
`;
const Row = styled.a`
  position: relative;
  width: 340px;
  height: 62px;
  min-height: 62px;
  background: ${({ theme }) => theme.color.bg};
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 0px 10px;
  &:hover {
    background: ${({ theme }) => theme.color.secondaryBg};
  }
  &.notread {
    background: ${({ theme }) => theme.color.secondaryBg};
  }
  @media only screen and (max-width: 576px) {
    width: 100%;
    height: 60px;
    min-height: 60px;
  }
`;

const Avatar = styled.div`
  cursor: pointer;
  background: ${({ theme }) => theme.color.bg};
  border-radius: 4px;
  width: 42px;
  height: 42px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.color.secondaryBg};
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
const EmojiIcon = styled.div`
  font-size: 20px;
  line-height: 1;
`;
const Text = styled.div`
  width: calc(100% - 54px);
  height: 44px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: space-around;
`;
const TopRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;
const Name = styled.div`
  color: ${({ theme }) => theme.color.darkerText};
  font-family: "Poppins Medium";
  font-size: 13px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
const Badge = styled.div`
  flex: 0 0 auto;
  font-family: "Poppins Medium";
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.color.border};
  background: ${({ theme }) => theme.color.bg};
  color: ${({ theme }) => theme.color.lighterText};

  &.pending {
    background: rgba(245, 158, 11, 0.12);
    border-color: rgba(245, 158, 11, 0.25);
    color: #f59e0b;
  }
  &.accepted {
    background: rgba(16, 185, 129, 0.12);
    border-color: rgba(16, 185, 129, 0.25);
    color: #10b981;
  }
  &.declined {
    background: rgba(239, 68, 68, 0.12);
    border-color: rgba(239, 68, 68, 0.25);
    color: #ef4444;
  }
`;
const Massege = styled.div`
  width: 100%;
  color: ${({ theme }) => theme.color.lighterText};
  font-family: "Poppins Regular";
  font-size: 11px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
// const Time = styled.p`
//   text-transform: lowercase;
//   position: absolute;
//   right: 10px;
//   top: 7px;
//   color: ${({ theme }) => theme.color.secondaryIcon};
//   font-family: "Poppins Regular";
//   font-size: 8px;
// `;

const Empty = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  & > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    & > img {
      width: 115px;
    }
    & > div {
      margin-top: 20px;
      color: ${({ theme }) => theme.color.lighterText};
      font-family: "Poppins Regular";
      font-weight: 500;
      font-size: 10px;
      line-height: 120%;
    }
  }
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
